import classNames from 'classnames';

import styles from './circle-checkbox.module.css';
import { SvgIcon } from './svg-icon';

const D_EMPTY =
  'M19.5 10C19.5 15.2467 15.2467 19.5 10 19.5C4.7533 19.5 0.5 15.2467 0.5 10C0.5 4.7533 4.7533 0.5 10 0.5C15.2467 0.5 19.5 4.7533 19.5 10Z';

const D_CHECKED_BG =
  'M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10Z';

const D_CHECKED_MARK =
  'M16.4705 6.33976L8.30328 16.4706L3.5293 11.8678L5.09021 10.0098L8.094 12.9059L14.7046 4.70593L16.4705 6.33976Z';

interface CircleCheckboxProps {
  width?: string;
  height?: string;
  checked: boolean;
  isDisabled?: boolean;
  /* Opt-in monochrome-ink checked fill (instead of #3BCE7B). Set by the
     report-builder "report" and the data-enrichment "columns" card variants. */
  themed?: boolean;
}

export function CircleCheckbox({
  checked,
  themed,
  height = '24px',
  width = '24px',
  isDisabled,
}: CircleCheckboxProps) {
  return (
    <label className={styles.label}>
      <div>
        {checked ? (
          <CircleChecked
            width={width}
            height={height}
            themed={themed}
            className={classNames(
              themed && styles['checked'],
              isDisabled && styles['disabled']
            )}
          />
        ) : (
          <SvgIcon
            width={width}
            height={height}
            viewBox="0 0 20 20"
            className={themed ? styles['empty'] : undefined}
          >
            <path
              fill="none"
              d={D_EMPTY}
              stroke="#2D426A"
              strokeOpacity="0.2"
            />
          </SvgIcon>
        )}
      </div>
    </label>
  );
}

type CircleCheckedProps = {
  height?: number | string;
  width?: number | string;
  className?: string;
  /* When set (report-builder variant), render the Figma centre dot instead of
     the checkmark (138:17151 dark / 138:18460 light). */
  themed?: boolean;
};
export function CircleChecked({
  width = '1em',
  height = '1em',
  className,
  themed,
}: CircleCheckedProps) {
  return (
    <SvgIcon
      width={width}
      height={height}
      className={className}
      viewBox="0 0 20 20"
    >
      <path fill="#3BCE7B" d={D_CHECKED_BG} />
      {themed ? (
        <circle
          className={styles['checkDot']}
          cx="10"
          cy="10"
          r="5"
          fill="white"
        />
      ) : (
        <path fill="white" d={D_CHECKED_MARK} />
      )}
    </SvgIcon>
  );
}
